// Gatsby supports TypeScript natively!
import React from "react"
import { PageProps, Link } from "gatsby"
import Contact from "../components/contact"

import Layout from "../components/layout"
import SEO from "../components/seo"

const SecondPage = (props: PageProps) => (
  <Layout>
    <SEO title="Contact" />
      <Contact />
      <div className="contact-page-div" id="formlink">
      <h2>Fill Contact Form</h2>
      <form className="form-contact"
      name="contact"
      method="post"
      data-netlify="true"
      data-netlify-honeypot="bot-field"
      style={{marginBottom:"0px"}}
    >
      <input type="hidden" name="form-name" value="contact" />
      <p>
        <label>
          Name: <input className="input-box" type="text" name="name" placeholder="Your Name" />
        </label>
      </p>
      <p>
        <label>
          Email: <input className="input-box" type="email" name="email" placeholder="mailid@gmail.com" />
        </label>
      </p>
      <p>
        <label>
          Message: <textarea className="input-box" name="message" placeholder="Your Message"></textarea>
        </label>
      </p>
      <p>
        <button className="btn btn-default" type="submit">Send</button>
      </p>
    </form>
    </div>
  </Layout>
)

export default SecondPage
